import React from 'react';
import DropDown from '../DropDown/DropDown';
import MultiDropDownAsync from '../DropDown/MultiDropDownAsync/MultiDropDownAsync';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import '../../styles/react_dates_overrides.css';
import { communicationTypeFilterItems } from '../../constants/conversationTypes';
import { ResetAllButton } from '../common/buttonsComponents';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  changeCommunicationTypeForEscalatedFilter,
  changeExcludeBusinessesForEscalatedFilter,
  changeSelectedBusinessesForEscalatedFilter,
  clearEscalatedFilters,
  filterEscalatedTickets,
} from '../../actions/escalatedTabFiltersActions';
import {
  getExcludeSelectedBusinessesForEscalatedTabFilter,
  getSelectedBusinessesForEscalatedTabFilter,
  getSelectedCommunicationTypeIdForEscalatedTabFilter,
} from '../../selectors/filters';
import {
  businessDetailsNextPageExist,
  getBusinessesNamesAndIds,
  getBusinessNameAndIdById,
  isSpecialistLite,
} from '../../extractFromState';
import {
  AdminTools,
  BusinessToggleHolder,
  CheckboxHolder,
  Divider,
  FilterHolder,
  FilterLabel,
  FiltersGroup,
  ShowSmbFilter,
  CheckboxStandinImage,
  SmbFilterHolder,
  SwitchFiltersButton,
  SwitchFiltersImage,
} from './EscalatedTabFilters.styles';
import { ALLOWED_STATUSES_FOR_TICKET_FILTER } from '../../constants/accountStatuses';
import * as businessActions from '../../actions/businessActions';

export class EscalatedTabFilters extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showFilters: true,
      showBusinessFilter: true,
    };
  }

  async componentDidMount() {
    this.setState({ businessDetailsIsLoading: true });
    await this.props.onSetBusinessesDetailsSearchParamsAndLoad('', ALLOWED_STATUSES_FOR_TICKET_FILTER);
    this.setState({ businessDetailsIsLoading: false });
  }

  // Communication type filter
  onCommunicationTypeFilterValueChangedHandler = (filterId) => {
    this.props.changeCommunicationTypeForEscalatedFilter(filterId);
    this.props.filterEscalatedTickets();
  };

  renderCommunicationTypeFilter() {
    const { selectedCommunicationFilterId } = this.props;

    return (
      <DropDown
        label="Type"
        title="Type"
        list={communicationTypeFilterItems}
        maxWidth="100px"
        selected={{ id: selectedCommunicationFilterId }}
        onSelectFunction={this.onCommunicationTypeFilterValueChangedHandler}
      />
    );
  }
  // Communication type filter end

  // Reset escalated filters button
  clearEscalatedFiltersButtonHandler = () => {
    this.props.clearEscalatedFilters();
    this.props.filterEscalatedTickets();
  };

  renderResetAllFiltersButton() {
    return <ResetAllButton onClick={this.clearEscalatedFiltersButtonHandler}>Reset All</ResetAllButton>;
  }
  // Reset escalated filters button end

  // Business filter toggle
  onToggleBusinessFilterHandler = () => {
    this.setState({ showBusinessFilter: !this.state.showBusinessFilter });
  };

  renderBusinessFilterToggle() {
    const toggleImage = this.state.showBusinessFilter
      ? '/images/checkboxes/checked.svg'
      : '/images/checkboxes/unchecked.svg';

    return (
      <ShowSmbFilter onClick={this.onToggleBusinessFilterHandler}>
        <CheckboxStandinImage src={toggleImage} />
        <FilterLabel>Show Partner Filter</FilterLabel>
      </ShowSmbFilter>
    );
  }
  // Business filter toggle end

  // Exclude businesses toggle
  onExcludeBusinessesToggleChangeHandler = () => {
    // only refresh it if we have businesses in the filter
    const isAnyFilteredBusinessesPresent = this.props.selectedBusinessIdList.length > 0;
    this.props.changeExcludeBusinessesForEscalatedFilter(!this.props.excludeSelectedBusinessInFilter);
    if (isAnyFilteredBusinessesPresent) {
      this.props.filterEscalatedTickets();
    }
  };

  renderExcludeBusinessesToggle() {
    const { excludeSelectedBusinessInFilter } = this.props;

    const toggleImage = excludeSelectedBusinessInFilter
      ? '/images/checkboxes/checked.svg'
      : '/images/checkboxes/unchecked.svg';

    return (
      <CheckboxHolder>
        <CheckboxStandinImage src={toggleImage} onClick={this.onExcludeBusinessesToggleChangeHandler} />
        <FilterLabel>Exclude Partners</FilterLabel>
      </CheckboxHolder>
    );
  }
  // Exclude businesses toggle end

  // Business select filter
  onBusinessSelectFilterValuesChangedHandler = (optionList) => {
    const selectedSMBIdList = optionList.map((option) => option.value);
    this.props.changeSelectedBusinessesForEscalatedFilter(selectedSMBIdList);
    this.props.filterEscalatedTickets();
  };

  onBusinessSelectInputChange = async (inputValue) => {
    await this.props.onSetBusinessesDetailsSearchParamsAndLoad(inputValue, ALLOWED_STATUSES_FOR_TICKET_FILTER);
  };

  renderBusinessSelectFilter() {
    const { selectedBusinessList, businessNames, onBusinessesDetailsPageLoad } = this.props;

    return (
      <MultiDropDownAsync
        label="Partner:"
        selectedIdList={selectedBusinessList}
        options={businessNames}
        onInputChange={this.onBusinessSelectInputChange}
        onLoad={onBusinessesDetailsPageLoad}
        onChange={this.onBusinessSelectFilterValuesChangedHandler}
        nextPageExist={this.props.businessDetailsNextPageExist}
        isLoading={this.state.businessDetailsIsLoading}
      />
    );
  }
  // Business select filter end

  renderFilterContent() {
    return (
      <>
        <FiltersGroup>
          <FilterHolder width="75%">{this.renderCommunicationTypeFilter()}</FilterHolder>
          <FilterHolder width="25%">{this.renderResetAllFiltersButton()}</FilterHolder>
        </FiltersGroup>
        <FiltersGroup />
        <FiltersGroup>
          <BusinessToggleHolder>
            {this.renderBusinessFilterToggle()}
            {this.state.showBusinessFilter && this.renderExcludeBusinessesToggle()}
          </BusinessToggleHolder>
          {this.state.showBusinessFilter && (
            <SmbFilterHolder width="70%">{this.renderBusinessSelectFilter()}</SmbFilterHolder>
          )}
        </FiltersGroup>
      </>
    );
  }

  onSwitchFiltersButtonClickHandler = () => {
    this.setState({ showFilters: !this.state.showFilters });
  };

  render() {
    return (
      <Divider>
        <AdminTools>
          <SwitchFiltersButton onClick={this.onSwitchFiltersButtonClickHandler}>
            <FilterLabel>Escalated filters</FilterLabel>
            <FilterLabel>
              {this.state.showFilters ? 'Hide' : 'Show'}
              <SwitchFiltersImage
                src={
                  this.state.showFilters
                    ? '/images/new-designs/chevron-up-blue.svg'
                    : '/images/new-designs/chevron-down-blue.svg'
                }
                alt=""
              />
            </FilterLabel>
          </SwitchFiltersButton>
          {this.state.showFilters && this.renderFilterContent()}
        </AdminTools>
      </Divider>
    );
  }
}

export const mapStateToProps = (state) => {
  const businessNames = getBusinessesNamesAndIds(state);
  const selectedBusinessIdList = getSelectedBusinessesForEscalatedTabFilter(state);

  return {
    businessDetailsNextPageExist: businessDetailsNextPageExist(state),
    selectedBusinessList: selectedBusinessIdList.map((id) => getBusinessNameAndIdById(state, id)),
    excludeSelectedBusinessInFilter: getExcludeSelectedBusinessesForEscalatedTabFilter(state),
    selectedCommunicationFilterId: getSelectedCommunicationTypeIdForEscalatedTabFilter(state),
    isSpecialistLite: isSpecialistLite(state),
    businessNames,
    selectedBusinessIdList,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      filterEscalatedTickets,
      changeSelectedBusinessesForEscalatedFilter,
      changeExcludeBusinessesForEscalatedFilter,
      changeCommunicationTypeForEscalatedFilter,
      onSetBusinessesDetailsSearchParamsAndLoad: businessActions.setBusinessesDetailsSearchParamsAndLoad,
      onBusinessesDetailsPageLoad: businessActions.businessesDetailsPageLoad,
      clearEscalatedFilters,
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(EscalatedTabFilters);
